import React from 'react';
import { DiamondIcon } from 'app/components/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@progress/kendo-react-buttons';
import './SubscriptionBlock.less';
import clsx from 'clsx';

interface Props {
  buttonLabel?: string;
  className?: string;
  onClick: () => void;
}

export default function SubscriptionBlock({
  buttonLabel,
  className,
  onClick,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={clsx('subscription-block', className)}>
      <div className="subscription-block__icon-wrapper">
        <DiamondIcon width={32} height={32} />
      </div>

      <div>
        <h5 className="subscription-block__title">
          {t('unlock_premiun_features')}
        </h5>

        <p className="subscription-block__description">
          {t('subscribe_to_kubota')}
        </p>

        <Button
          className="subscription-block__upgrade-button"
          themeColor="primary"
          onClick={onClick}
        >
          {buttonLabel ?? t('upgrade')}
        </Button>
      </div>
    </div>
  );
}
